import { c as _c } from "react/compiler-runtime";
// Route table. The lists are routes and nesting is the book: a page's children are the pages after it, so the URL
// path is the stack of open lists (/settings/instances/michael/ontologies). Forms and details opened from a page are
// modals in ?params (layouts/modals.tsx: the Sheet on phones, a page after theirs on desktop). Any other path is a
// kind view's page (src/views), else the board. The shell
// (layouts/root.tsx) draws the nav, the matched pages, then the task detail. /login is outside the shell.
import { Route, Routes } from "react-router";
import { BoardRoute, ChatsRoute, GraphRoute, InstanceRoute, InstancesRoute, OntologiesRoute, SecretsRoute, SettingsRoute, ToInstances, ViewPage } from "./layouts/pages";
import { Shell } from "./layouts/root";
import { LoginPage } from "./pages/login";
export function AppRoutes() {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Route path="/login" element={<LoginPage />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Shell />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Route index={true} element={<BoardRoute />} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Route path="graph" element={<GraphRoute />} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Route path="chats" element={<ChatsRoute />} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Route path="secrets" element={<SecretsRoute />} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SettingsRoute />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <InstancesRoute />;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <InstanceRoute />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Route path="settings" element={t6}><Route path="instances" element={t7}><Route path=":instance" element={t8}><Route path="ontologies" element={<OntologiesRoute />} /></Route></Route></Route>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Route path="ontologies" element={<OntologiesRoute />} />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Route path="connections" element={<ToInstances />} />;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Routes>{t0}<Route element={t1}>{t2}{t3}{t4}{t5}{t9}{t10}{t11}<Route path="*" element={<ViewPage />} /></Route></Routes>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  return t12;
}